module.exports = __webpack_public_path__ + "media.7a159e8693b18526a2df.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/media/webfont/media.svg
// module id = ../../../../../src/assets/fonts/line-icons-pro/media/webfont/media.svg
// module chunks = styles